import { render, staticRenderFns } from "./SendRecipient.vue?vue&type=template&id=203bed8a"
import script from "./SendRecipient.vue?vue&type=script&lang=js"
export * from "./SendRecipient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports